import { render, staticRenderFns } from "./CustomOperationDetailsContent.vue?vue&type=template&id=5f10f3ef&scoped=true"
import script from "./CustomOperationDetailsContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomOperationDetailsContent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomOperationDetailsContent.vue?vue&type=style&index=0&id=5f10f3ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10f3ef",
  null
  
)

export default component.exports